import React from 'react';
import { Popup } from 'semantic-ui-react';
import ArrowCircleIcon from 'assets/icons/menu-icons/ArrowCircleIcon';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './FixateMenuButton.module.scss';
function FixateMenuButton(props) {
  return (
    <div>
      {props.menuState.close ? (
        <div className={styles.buttonDrop} onClick={props.handleState}>
          <ArrowCircleIcon className={styles.iconDropClosed} />
        </div>
      ) : !props.menuState.close && props.menuState.fixed ? (
        <div className={styles.buttonDrop} onClick={props.handleState}>
          <Popup
            content='Aperte para desfixar'
            trigger={<ArrowCircleIcon className={styles.iconDropOpen} />}
          />
        </div>
      ) : !props.menuState.close && !props.menuState.fixed ? (
        <div className={styles.buttonDrop} onClick={props.handleState}>
          <Popup
            content='Aperte para fixar'
            trigger={<ArrowCircleIcon className={styles.iconDropOpenNoFixed} />}
          />
        </div>
      ) : (
        <div className={styles.buttonDrop} onClick={props.handleState}>
          <ArrowCircleIcon className={styles.iconDropOpen} />
        </div>
      )}
    </div>
  );
}

FixateMenuButton.propTypes = {
  close: PropTypes.bool,
  fixed: PropTypes.bool,
  menuState: PropTypes.object,
  handleState: PropTypes.func
};

const mapStateToProps = state => ({
  close: state.close,
  fixed: state.fixed
});

export default connect(mapStateToProps)(FixateMenuButton);
